import Modal from '../../components/common/Modal';
import Avatar from '../../components/common/Avatar';
import EmptyState from '../../components/common/EmptyState';
import useEventsStore from '../../store/useEventsStore';
import useParentsStore from '../../store/useParentsStore';
import { avatarFor } from '../../utils/avatar';

/* Who said yes/no to a sent invitation. */
export default function AttendanceModal({ eventId, onClose }) {
  const event = useEventsStore((s) => s.events.find((e) => e.id === eventId));
  const parents = useParentsStore((s) => s.parents);
  const open = eventId != null && !!event;

  const rsvps = event?.rsvps || [];
  const yes = rsvps.filter((r) => r.response === 'yes');
  const no = rsvps.filter((r) => r.response === 'no');

  const rows = (list) =>
    list.length ? (
      list.map((r, i) => {
        const av = avatarFor(r.name, parents);
        return (
          <div className="response-row" key={i}>
            <Avatar initials={av.initials} color={av.color} size={34} fontSize={12} />
            <div className="info">
              <div className="nm">{r.name}</div>
            </div>
          </div>
        );
      })
    ) : (
      <EmptyState>No one yet.</EmptyState>
    );

  return (
    <Modal open={open} onClose={onClose} title={event ? `${event.title} — Attendance` : 'Attendance'} maxWidth={420}>
      <div style={{ marginBottom: 14 }}>
        <div className="hint" style={{ marginBottom: 8 }}>GOING ({yes.length})</div>
        {rows(yes)}
      </div>
      <div>
        <div className="hint" style={{ marginBottom: 8 }}>CAN'T MAKE IT ({no.length})</div>
        {rows(no)}
      </div>
    </Modal>
  );
}
